import { Component, OnInit } from "@angular/core";
import { FeatureFlagsService } from "../agilx/shared/feature-flags.service";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";

@Component({
  selector: "app-dispatch-schedule",
  templateUrl: "./dispatch-schedule.component.html",
  styleUrls: ["./dispatch-schedule.component.css"],
})
export class DispatchScheduleComponent implements OnInit {
  activeTab: "driver-assignments" | "unassigned-drivers" | "dispatch-finder" = "driver-assignments";
  private readonly STORAGE_KEY = "dispatch-schedule-active-tab";

  constructor(
    private featureFlagsService: FeatureFlagsService,
    private authService: authenticationService
  ) {}

  ngOnInit(): void {
    // Load saved tab from localStorage
    const savedTab = localStorage.getItem(this.STORAGE_KEY) as
      | "driver-assignments"
      | "unassigned-drivers"
      | "dispatch-finder"
      | null;

    if (savedTab && this.isValidTab(savedTab) && this.isTabVisible(savedTab)) {
      this.activeTab = savedTab;
    } else {
      // If saved tab is not visible, set to first visible tab
      this.activeTab = this.getFirstVisibleTab();
    }
  }

  setActiveTab(tab: "driver-assignments" | "unassigned-drivers" | "dispatch-finder"): void {
    this.activeTab = tab;
    // Save to localStorage
    localStorage.setItem(this.STORAGE_KEY, tab);
  }

  private isValidTab(
    tab: string
  ): tab is "driver-assignments" | "unassigned-drivers" | "dispatch-finder" {
    return ["driver-assignments", "unassigned-drivers", "dispatch-finder"].includes(tab);
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.featureFlagsService.isEnabled(featureName as any);
  }

  hasPermission(permissionName: string): boolean {
    const permission = Permissions[permissionName];
    return this.authService.hasPermission(permission);
  }

  private isTabVisible(
    tab: "driver-assignments" | "unassigned-drivers" | "dispatch-finder"
  ): boolean {
    if (tab === "driver-assignments") {
      return this.isFeatureEnabled("dispatchDriverAssignments") && this.hasPermission("DispatchDriverAssignmentsRead");
    }
    if (tab === "dispatch-finder") {
      return this.isFeatureEnabled("dispatchFinder") && this.hasPermission("DispatchFinderRead");
    }
    return true; // unassigned-drivers or other tabs are always visible
  }

  private getFirstVisibleTab(): "driver-assignments" | "unassigned-drivers" | "dispatch-finder" {
    if (this.isFeatureEnabled("dispatchDriverAssignments") && this.hasPermission("DispatchDriverAssignmentsRead")) {
      return "driver-assignments";
    }
    if (this.isFeatureEnabled("dispatchFinder") && this.hasPermission("DispatchFinderRead")) {
      return "dispatch-finder";
    }
    return "driver-assignments"; // fallback
  }
}
